import { Empty } from 'antd';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './MainFlatsGrid.module.scss';
import IndicatorsRow from '../../../../../../../../containers/HousingStock/components/ui/IndicatorsRow/IndicatorsRow';
import { useStagesQuery } from '../../../../../../../HousingStock/hooks/useStageLifeCircleQuery';
import { addressStagesColorsMap } from '../../../../../../../HousingStock/constants/stagesColorMaps';
import FlatsGrid from '../FlatsGrid/FlatsGrid';
import ExpandedContent from '../ExpandedContent/ExpandedContent';
import EntranceTabs from '../EntranceTabs/EntranceTabs';

const EmptyFlatsGrid = () => {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Для данного адреса шахматка отсутствует"
    />
  );
};

const emptyArr = [];

const select = (data) => {
  const stages = data?.stagesAddressLifeCycle;

  return stages?.length
    ? stages.map((stage) => ({
        id: stage.id,
        value: stage.name,
        bg: addressStagesColorsMap.get(stage.id) || 'transparent',
      }))
    : emptyArr;
};

const ContentFlatsGrid = ({ gridData, baseActiveFlat }) => {
  const activeFlatRef = useRef(null);
  const parentContainerRef = useRef(null);

  const [activeFlat, setActiveFlat] = useState(baseActiveFlat);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [parentContainer, setParentContainer] = useState(null);
  const [activeEntranceName, setActiveEntranceName] = useState(
    `${baseActiveFlat?.porch}-й подъезд`
  );
  const [entrancesInView, setEntrancesInView] = useState([]);

  const { data: stages } = useStagesQuery({ staleTime: Infinity, select });

  const handleFlatClick = (data) => {
    setActiveFlat(activeFlat?.addressId === data.addressId ? null : data);
  };

  const handleChangeEntranceName = (value) => {
    setActiveEntranceName(value);
  };

  useEffect(() => {
    const container = parentContainerRef.current;

    setParentContainer(container);
    if (container && currentEntry) {
      container.scrollTo({
        left: currentEntry.offsetLeft - 10,
        behavior: 'smooth',
      });
    }
  }, [currentEntry]);

  useEffect(() => {
    if (activeFlat && activeFlatRef.current) {
      activeFlatRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [activeFlat]);

  return (
    <>
      <div className={styles.indicatorsRow}>
        {/* <IndicatorsRow indicators={requestInFlatIndicators} /> */}
        <EntranceTabs
          onChange={handleChangeEntranceName}
          entrancesInView={entrancesInView}
          className={styles.tabs}
          gridData={gridData}
        />

        <IndicatorsRow
          indicators={stages || emptyArr}
          squareIndicator
        />
      </div>
      <div
        className={styles.root}
        ref={parentContainerRef}
      >
        <div className={styles.wrapper}>
          {gridData?.map((item) => (
            <FlatsGrid
              key={item.name}
              className={styles.card}
              data={item}
              setCurrentEntry={setCurrentEntry}
              onFlatClick={handleFlatClick}
              colSize="60px"
              parentContainer={parentContainer}
              activeFlat={activeFlat}
              activeEntranceName={activeEntranceName}
              entrancesInView={entrancesInView}
              setEntrancesInView={setEntrancesInView}
            />
          ))}
        </div>
      </div>
      <div ref={activeFlatRef}>
        {!!activeFlat && <ExpandedContent flatData={activeFlat} />}
      </div>
    </>
  );
};

const MainFlatsGrid = ({ flatsGridData, baseActiveFlat }) => {
  return flatsGridData?.length ? (
    <ContentFlatsGrid
      gridData={flatsGridData}
      baseActiveFlat={baseActiveFlat}
    />
  ) : (
    <EmptyFlatsGrid />
  );
};

export default MainFlatsGrid;
